function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M23.5 33a9 9 0 009-9V9a9 9 0 00-18 0v15a9 9 0 009 9zm15-15H37c-.83 0-1.5.67-1.5 1.5V24c0 7.01-6.05 12.64-13.2 11.94-6.23-.6-10.8-6.21-10.8-12.47V19.5c0-.83-.67-1.5-1.5-1.5H8.5c-.83 0-1.5.67-1.5 1.5v3.77c0 8.4 6 15.89 14.25 17.03v3.2H16c-.83 0-1.5.67-1.5 1.5v1.5c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5V45c0-.83-.67-1.5-1.5-1.5h-5.25v-3.17C33.78 39.23 40 32.33 40 24v-4.5c0-.83-.67-1.5-1.5-1.5z"
})));